import { createMicroservicesClient } from '@cecm-microservices-sdk/core/client';
import { getRuntimeConfig } from '@/services/runtimeConfig';

function getRuntimeMicroservicesBaseUrls() {
    const runtimeConfig = getRuntimeConfig();

    return {
        baseUrlUS: runtimeConfig?.microservices.baseUrlUS || '',
        baseUrlCanada: runtimeConfig?.microservices.baseUrlCanada || '',
    };
}

export function getMicroservicesClient(currentCountryCode: 'us' | 'ca') {
    const runtimeBaseUrls = getRuntimeMicroservicesBaseUrls();

    return createMicroservicesClient({
        baseUrlUS: runtimeBaseUrls.baseUrlUS,
        baseUrlCanada: runtimeBaseUrls.baseUrlCanada,
        currentCountryCode,
    });
}
